import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button/Button';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

import { toggleDeclineInviteReasonPopup } from '../../redux/reducers/view';
import { messageSendRequest } from '../../redux/reducers/message';
import Popup from '../Popup';

import { commonStyles } from '../../styles/styles';
import addUserImage from '../../assets/icon_feather.svg';
import addUserSuccessImage from '../../assets/message_sent.svg';

const AddUserPopup = ({
  classes,
  handleSendInviteDeclineWithReason,
  handleCloseInviteDeclineWithReasonPopup,
  handleTextArea,
  view,
}) => (
  <Popup>
    <div className={classes.popup}>
      <div className={`${classes.popupContent} ${classes.popupContentInviteDeclineReason}`}>
        <div className={classes.popupHeader}>
          <Clear className={classes.closePopup} onClick={handleCloseInviteDeclineWithReasonPopup} />
          <img
            src={view.addUserPopupSuccess ? addUserSuccessImage : addUserImage}
            alt="Icon feather"
            className={classes.image}
          />
          <Typography variant="headline" gutterBottom className={classes.popupHeaderText}>
            Please let us know why ?
          </Typography>
          <TextField
            id="with-placeholder"
            className={`${classes.textField} ${classes.popupTextArea}`}
            placeholder="Optional"
            onChange={handleTextArea}
            multiline
            InputProps={{
              disableUnderline: true,
              className: classes.textField,
            }}
          />
          <Button
            variant="contained"
            className={`${classes.defaultButton} ${classes.button} ${classes.messageContentButton}`}
            onClick={handleSendInviteDeclineWithReason}
          >
            SEND
          </Button>
        </div>
      </div>
    </div>
  </Popup>
);

const styles = () => ({
  ...commonStyles,
  popupContentInviteDeclineReason: {
    width: 450,
    paddingBottom: 30,
  },
  popupHeaderText: {
    margin: '10px 0 30px',
    fontSize: 16,
  },
  popupTextArea: {
    width: 353,
    height: 145,
    border: '1px solid #fff',
    padding: 10,
    marginBottom: 30,
  },
});

const mapDispatchToProps = dispatch => ({
  toggleDeclineInviteReasonPopup: value => dispatch(toggleDeclineInviteReasonPopup(value)),
  messageSendRequest: messageContent => dispatch(messageSendRequest(messageContent)),
});

const mapStateToProps = state => ({
  view: state.viewReducer,
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('textAreaField', 'handleTextAreaField', ''),
  withHandlers({
    handleSendInviteDeclineWithReason: props => () => {
      const { messageSendRequest, toggleDeclineInviteReasonPopup } = props;
      messageSendRequest({
        subject: '- INVITATION -',
        message: props.textAreaField,
        status: 'decline',
      });
      toggleDeclineInviteReasonPopup(false);
    },
    handleCloseInviteDeclineWithReasonPopup: props => e => {
      e.preventDefault();
      props.toggleDeclineInviteReasonPopup(false);
    },
    handleTextArea: props => event => {
      props.handleTextAreaField(event.target.value);
    },
  }),
  withStyles(styles),
)(AddUserPopup);

AddUserPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  view: PropTypes.instanceOf(Object),
  handleSendInviteDeclineWithReason: PropTypes.func,
  handleCloseInviteDeclineWithReasonPopup: PropTypes.func,
  handleTextArea: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/Popups/InviteDeclineReasonPopup.jsx